import(/* webpackMode: "eager" */ "/tmp/farbin-redis-build.wLbAye/src/app/global-error.tsx");
